
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iotdm/device/getRedisRealTimeData"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xieyibianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item v-show="false" :label="$t('xieyibianma')">
            <el-input v-model="yt.conditions.codeDesc"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" @click="filterRealData(yt.conditions.code)" style="color: #419FFF; cursor: pointer;">
              {{$t('queren')}}
            </el-button>
            <el-button @click="yt.clear({sn: deviceSn})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>

        </el-form>
      </template>
    </yi_curd_table>

  </div>
</template>

<script type="text/javascript">
	export default {
		/* 唯一命名 */
		name: 'admin_iotdm_protocol_realtime_data',
		data() {
			return {
        hasSearched: false,
        originalDataList: [],
        deviceSn: String,
				columns: [{
					label: 'xieyibianma',
					prop: 'code'
				}, {
          label: 'shishishuju',
          prop: 'value'
        }, {
					label: 'gengxinshijian',
					prop: 'timestamp',
          type: 'time',
          width: 180,
          sort:'number',
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
          sn: this.$attrs.device.sn
				}
				this.yt.get(1);
        this.yt.isShowPagination = false;
        this.deviceSn = this.$attrs.device.sn;
			}, 300);
		},
		methods: {
			beforeAdd(params, url) {
        params.sn = this.$attrs.device.sn
				return params
			},
      filterRealData(code){
        if (!this.hasSearched){
          this.originalDataList = JSON.parse(JSON.stringify(this.yt.list));
          this.hasSearched = true;
        }
        console.log(this.originalDataList)
        //this.yt.list.filter(data => !code || data.code.toLowerCase().includes(code.toLowerCase()))
        this.yt.list = this.originalDataList.filter(data => !code || data.code.toLowerCase().includes(code.toLowerCase()))
      }

		}
	};
</script>


<style scoped lang="scss">
	.shift {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
	}
</style>
